import { Nullable } from "../types/common";
import lodash from "lodash";

export const enumIncludes = (list: any, value: string) =>
  Object.values(list).includes(value as typeof list);

export const isDefined = (value: any): boolean => value !== undefined;

export const isEqual = (objectA: any, objectB: any): boolean => lodash.isEqual(objectA, objectB);

export const toString = (value: Nullable<number | string | undefined>): string =>
  value ? String(value) : "";
